import { SCALES, GROUPS, LIKERT } from '../surveys/prores-2-5.js'

// Mittelwert pro Skala (1-6). Ergebnis-Profil mit personal/organisational Gruppen.
// Auswertung laut Spec: Summe der Punkte / Anzahl beantworteter Items pro Kürzel.
export function computeProRes(data) {
  const answers = data?.answers || {}
  const result = {
    personal: [],
    organisational: [],
    overall: { answered: 0, total: 0, average: null },
  }

  for (const group of GROUPS) {
    for (const scaleId of group.scaleIds) {
      const scale = SCALES[scaleId]
      let sum = 0, n = 0
      for (const it of scale.items) {
        const v = answers[it.key]
        if (typeof v === 'number' && v >= 1 && v <= 6) {
          sum += v
          n += 1
        }
      }
      const entry = {
        id: scale.code,
        scaleKey: scaleId,
        label: scale.label,
        description: scale.description,
        average: n > 0 ? sum / n : null,
        answered: n,
        total: scale.items.length,
      }
      result[group.id].push(entry)
      result.overall.answered += n
      result.overall.total += scale.items.length
    }
  }

  const allWithValues = [...result.personal, ...result.organisational].filter(s => s.average != null)
  result.overall.average = allWithValues.length
    ? allWithValues.reduce((a, s) => a + s.average, 0) / allWithValues.length
    : null

  return result
}

// Hilfs-Label: Mittelwert in eine grobe Interpretation
export function bandFor(avg) {
  if (avg == null) return null
  if (avg >= 5) return { label: 'Stark ausgeprägt', tone: 'strong' }
  if (avg >= 4) return { label: 'Gut ausgeprägt', tone: 'good' }
  if (avg >= 3) return { label: 'Mittel ausgeprägt', tone: 'mid' }
  if (avg >= 2) return { label: 'Wenig ausgeprägt', tone: 'low' }
  return { label: 'Sehr wenig ausgeprägt', tone: 'lowest' }
}

export const SCALE_MIN = LIKERT.values[0]
export const SCALE_MAX = LIKERT.values[LIKERT.values.length - 1]
